import { render, staticRenderFns } from "./DocumentLink.vue?vue&type=template&id=50f5afda"
import script from "./DocumentLink.vue?vue&type=script&lang=ts"
export * from "./DocumentLink.vue?vue&type=script&lang=ts"
import style0 from "./DocumentLink.vue?vue&type=style&index=0&id=50f5afda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports